import { Component, Vue } from 'vue-property-decorator'

const npAuth = 'auth';

//Vuex
import { Action, Getter } from 'vuex-class';

import links from '@/services/links';

// services
import { getAllMapTiposDoc } from '@/services/documentosService'

@Component({

})
export default class AdminNavbar extends Vue {

  @Action('logout', { namespace: npAuth }) dispatchLogout: any;

  links = links

  arrTiposDocs = getAllMapTiposDoc()

  logout(){
		this.dispatchLogout()
		this.$router.push("/login")
	}

}
